import { render } from "./SurveyLayout.vue?vue&type=template&id=6ddd91fb&scoped=true"
import script from "./SurveyLayout.vue?vue&type=script&lang=js"
export * from "./SurveyLayout.vue?vue&type=script&lang=js"

import "./SurveyLayout.vue?vue&type=style&index=0&id=6ddd91fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddd91fb"]])

export default __exports__